
const Container = ({children})=> {
    return <div style={{padding: 10}}>{children}</div>
}

export default Container;